module.exports = __webpack_public_path__ + "static/snapchat-cert-711c2516fc6aeca8e566dc978b867897.png";